




















import gql from 'graphql-tag';
import Component from 'vue-class-component';

import { BaseVue } from '@/BaseVue';
import UiLoading from '@/components/ui/UiLoading.vue';
@Component({
  components: {
    UiLoading,
  },
  apollo: {
    ReportMetadata: {
      query: gql`
        query getBiReportMetadata($orgId: ID!) {
          getBiReportMetadata(orgId: $orgId) {
            orgId
            embedUrl
          }
        }
      `,
      variables() {
        return {
          orgId: this.$store.state.currentOrg.id,
        };
      },
      update(data) {
        if (data && data.getBiReportMetadata) {
          this.embedUrl = data.getBiReportMetadata.embedUrl;
        }
      },
      loadingKey: 'isGraphqlLoading',
    },
  },
})
export default class BIRepors extends BaseVue {
  public isLoading = true;
  public isGraphqlLoading = 0;
  public embedUrl = '';

  public onLoad() {
    this.isLoading = false;
  }
}
